import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToDocumentStatusUpdated = (
  documentId: AnyDocument['id'],
  onUpdate: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.DocumentStatusChange],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    documentId ? buildDocumentChannelName(documentId) : undefined,
    DocumentPrivateWebsocketEvent.DocumentStatusChange,
    onUpdate,
  );
};
